module.exports = __webpack_public_path__ + "static/media/trip icon.8b615a11.svg";